import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { carreraTheme } from './theme';
import Header from './components/Header';
import AnmeldePage from './pages/AnmeldePage';
import FeedbackPage from './pages/FeedbackPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'; // <-- NEU
import AgreementPage from './pages/AgreementPage'; // <-- NEU
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { LanguageProvider } from './LanguageContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from "./components/Footer"; // <-- NEU

// Diese Komponente kapselt das Layout für die Hauptseiten
const MainLayout = ({ children }) => (
    <Container component="main" maxWidth="md" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
        <Box
            sx={{
                width: '100%',
                marginTop: { xs: 4, sm: 8 },
                marginBottom: { xs: 4, sm: 8 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'white',
                padding: { xs: 3, sm: 5 },
                borderRadius: '16px',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
            }}
        >
            {children}
        </Box>
    </Container>
);

function App() {
    return (
        <LanguageProvider>
            <ThemeProvider theme={carreraTheme}>
                <CssBaseline />
                <BrowserRouter>
                    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                        <Header /> {/* Header ist immer sichtbar */}


                        <Routes>
                            <Route path="/" element={<MainLayout><AnmeldePage /></MainLayout>} />
                            <Route path="/feedback" element={<MainLayout><FeedbackPage /></MainLayout>} />
                            <Route path="/datenschutz" element={<PrivacyPolicyPage />} />
                            <Route path="/beta-tester-agreement" element={<AgreementPage />} />
                        </Routes>
                        <Footer />
                    </Box>
                </BrowserRouter>
            </ThemeProvider>
        </LanguageProvider>
    );
}

export default App;